export class ClientEmployments {
    id:number
    client_id: number
    employment_type: string
    employer_id: number
    employment_start_date: string
    employment_end_date: string

    public constructor(init?: Partial<ClientEmployments>){
        Object.assign(this,init);
    }
}
